export default "__VITE_PUBLIC_ASSET__1df3202a__"